import { render, staticRenderFns } from "./PricingTypes.vue?vue&type=template&id=f163be8c&"
import script from "./PricingTypes.vue?vue&type=script&lang=js&"
export * from "./PricingTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports